import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Product } from '../../../PIM/models/product.model';
import { ProductOrientation } from '../../../PIM/models/product-orientation.interface';
import { PimApiService } from '../../../PIM/services/pim-api.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-replenish-put-away-modal',
  templateUrl: './replenish-put-away-modal.component.html',
  styleUrls: ['./replenish-put-away-modal.component.scss'],
})
export class ReplenishPutAwayModalComponent {
  @Output() onApprove = new EventEmitter();

  @Output() onReject = new EventEmitter();

  product: Product;

  constructor(
    public dialogRef: MatDialogRef<ReplenishPutAwayModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      quantity: number;
      orientation: ProductOrientation | null;
      productId: number;
      locationSizeId: number | null;
    },
    private pimApiService: PimApiService,
  ) {}

  ngOnInit(): void {}

  approve() {
    this.onApprove.emit();
    this.dialogRef.close();
  }

  reject() {
    this.onReject.emit();
    this.dialogRef.close();
  }
}
